import React from "react";
import "./styles/WorkInProgress.css"; // Optional: for styling
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../dataManagement/uiDb/UiDb";
import { closeWorkInProgress } from "../../../../dataManagement/uiDb/GeneralDb";

const WorkInProgress: React.FC = () => {
  const generalDb = useSelector((state: RootState) => state.general);
  const dispatch = useDispatch();

  if (!generalDb.isWipOpen) return null;

  function handleClick() {
    dispatch(closeWorkInProgress());
  }
  return (
    <div className="wip-overlay" onClick={handleClick}>
      <div className="wip-popup">
        <span className="wip-icon">🛠️</span>
        <h3>Work in Progress</h3>
        <p>
          This functionality is not yet implemented. Our team is working on it!
        </p>
      </div>
    </div>
  );
};

export default WorkInProgress;
